export const BlogsData = [
  {
    title: 'Redux Middleware',
    content:
      'In this article, let us look at the Redux middleware feature in-depth, to understand its potential in better view.',
    tag: 'Redux',
    hasLink: true,
    url: 'https://www.infinijith.com/blog/redux/redux-middleware',
    img: 'https://www.infinijith.com:3443/storage/blog/195/medium.png',
  },
  {
    title: 'Redux in React',
    content:
      'Let’s look at some fundamental principles of Redux and the demonstration of how to use Redux in React. ',
    tag: 'React',
    hasLink: true,
    url: 'https://www.infinijith.com/blog/react/react-redux',
    img: 'https://www.infinijith.com:3443/storage/blog/194/medium.png',
  },
  {
    title: 'React Hooks (Part – 2)',
    content:
      'In this article, we will explore the types, rules, and a profound analysis of the react additional hooks. ',
    tag: 'React',
    hasLink: true,
    url: 'https://www.infinijith.com/blog/react/react-additional-hooks',
    img: 'https://www.infinijith.com:3443/storage/blog/193/medium.png',
  },
  {
    title: 'React Hooks (Part – 1)',
    content:
      'The focus of this article is to explore the nuances of Hooks and their types, rules, and a profound analysis of the basic hooks. ',
    tag: 'React',
    hasLink: true,
    url: 'https://www.infinijith.com/blog/react/react-basic-hooks',
    img: 'https://www.infinijith.com:3443/storage/blog/189/medium.png',
  },
  {
    title: 'React Vs Vue',
    content:
      'React & Vue are the two popular front-end development technologies preferred by developers. Let’s compare these to find the best one.',
    tag: 'React',
    hasLink: true,
    url: 'https://www.infinijith.com/blog/react/react-vs-vue',
    img: 'https://www.infinijith.com:3443/storage/blog/191/medium.png',
  },
  {
    title: 'Cross-Origin Resource Sharing',
    content:
      'All developers must have faced the CORS errors. What is CORS and how CORS errors occur? Let us discuss this concept in detail.',
    tag: 'Web Security',
    hasLink: true,
    url: 'https://www.infinijith.com/blog/web-security/cors',
    img: 'https://www.infinijith.com:3443/storage/blog/190/medium.png',
  },
  {
    title: 'Redis Cache in Express Node JS ',
    content:
      'This article discusses the Redis caching concept in express Nodejs. With the example, get started with Redis concept. ',
    tag: 'Node JS',
    hasLink: true,
    url: 'https://www.infinijith.com/blog/nodejs/redis-cache-in-express-nodejs',
    img: 'https://www.infinijith.com:3443/storage/blog/188/medium.png',
  },
  {
    title: 'Node-Cache with Express Node JS ',
    content:
      'Node Cache is one of the interesting concepts to increase performance of NodeJS application. Let us discuss it with an example. ',
    tag: 'Node JS',
    hasLink: true,
    url: 'https://www.infinijith.com/blog/nodejs/node-cache',
    img: 'https://www.infinijith.com:3443/storage/blog/187/medium.png',
  },
  {
    title: 'Communication between Microservices ',
    content:
      'In this article, we will learn about different ways of communication between microservices. ',
    tag: 'Node JS',
    hasLink: true,
    url: 'https://www.infinijith.com/blog/nodejs/microservices-communication',
    img: 'https://www.infinijith.com:3443/storage/blog/186/medium.png',
  },
  {
    title: 'Microservices Advantages in Node JS ',
    content:
      'Microservice architecture in NodeJS helps to improve the app performance. Let us discuss this topic in detail with an example.',
    tag: 'Node JS',
    hasLink: true,
    url: 'https://www.infinijith.com/blog/nodejs/microservices-in-nodejs',
    img: 'https://www.infinijith.com:3443/storage/blog/185/medium.png',
  },
  {
    title: 'Nodejs Cluster - Optimize App Performance',
    content:
      'App performance is so important! Learn how to optimize nodejs app performance with clustering concept.',
    tag: 'Node JS',
    hasLink: true,
    url: 'https://www.infinijith.com/blog/nodejs/nodejs-cluster',
    img: 'https://www.infinijith.com:3443/storage/blog/184/medium.jpg',
  },
];
